import { createFileRoute } from "@tanstack/react-router"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

const tabs = [
  {
    id: "roles",
    label: "Roles",
    path: `/app/admin/system-admin/roles`,
  },
  {
    id: "users",
    label: "Users",
    path: `/app/admin/system-admin/users`,
  },
]

export const Route = createFileRoute("/app/admin/system-admin/_layout")({
  component: SystemAdminLayout,
})

function SystemAdminLayout() {
  return <TabsLayout title='System admin' tabs={tabs} />
}
